<script setup lang="ts">
defineProps<{ error?: any; closeText?: string }>()

const emit = defineEmits(['close'])
</script>

<template>
  <el-alert v-if="error" type="error" :close-text="closeText" @close="emit('close')">
    <template #title>
      <template v-if="error.response">
        {{ error?.response?.data?.description ?? 'An unknown error occurred.' }}
      </template>
      <template v-else-if="error.request"> A request error occurred. </template>
      <template v-else> An unknown error occurred. </template>
    </template>
    <template #default>
      <template v-if="error.response">
        <ul v-if="error.response.data?.details?.length > 0">
          <li v-for="detail in error.response.data.details" :key="detail">{{ detail }}</li>
        </ul>
      </template>
      <template v-else-if="error.request"> Check your internet connection. </template>
      <template v-else
        >You can report this to us at <a href="mailto:developers@revolvelabs.ai"><b>developers@revolvelabs.ai</b></a
        >.</template
      >
      <slot />
    </template>
  </el-alert>
</template>
